import { NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SwiperOptions } from 'swiper/types';
// import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-featured-courses',
  templateUrl: './featured-courses.component.html',
  styleUrls: ['./featured-courses.component.scss'],
  standalone: true,
  imports: [AngularSvgIconModule, NgFor],
})
export class FeaturedCoursesComponent implements OnInit {
  readonly swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 15,
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1000,
    pagination: {
      el: '.featured-courses-pagination',
      type: 'bullets',
      clickable: true,
    },
  };

  readonly courses = [
    {
      title: 'Mastering Javascript - 2022 Edition',
      total_rate: 4,
      total_reviews: 223,
    },
    // {
    //   title: 'Being a Pragmatic Developer',
    //   total_rate: 5,
    //   total_reviews: 442,
    // },
  ];

  constructor() {}

  ngOnInit(): void {}

  numberToArray(number: number): number[] {
    return Array(number);
  }
}
